import React, { useEffect, useState } from "react";
import axios from "axios";
import { Card, Form, Table, Button, Spinner } from "react-bootstrap";
import API from "../utils/api";

const ClienteDashboard = () => {
  const [clientes, setClientes] = useState([]);
  const [clienteSel, setClienteSel] = useState("");
  const [clienteInfo, setClienteInfo] = useState(null);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [detalleVisible, setDetalleVisible] = useState(null);
const [busqueda, setBusqueda] = useState("");
const [mostrarLista, setMostrarLista] = useState(false);


  // =============================
  // CARGAR CLIENTES
  // =============================
  useEffect(() => {
    axios
      .get(API.urlAPI + "clientes")
      .then((res) => setClientes(res.data))
      .catch((err) => console.error(err));
  }, []);



  
const clientesFiltrados = clientes.filter((c) =>
  `${c.Nombre} ${c.Apellido}`
    .toLowerCase()
    .includes(busqueda.toLowerCase())
);

  // =============================
  // BUSCAR CLIENTE
  // =============================
  const buscarCliente = async (clienteObj) => {
    try {
      setLoading(true);

      const nombreCompleto = `${clienteObj.Nombre} ${clienteObj.Apellido}`;

      const res = await axios.get(
        API.urlAPI + "clientes/resumen",
        {
          params: { cliente: nombreCompleto },
        }
      );

      setClienteSel(nombreCompleto);
      setClienteInfo(clienteObj);
      setData(res.data);
      setDetalleVisible(null);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // =============================
  // HELPERS
  // =============================
  const esContado = (r) => Number(r.modalidad) === 0;

  const getModalidad = (m) => {
    const val = Number(m);

    if (val === 0) return "Contado";
    if (val >= 28) return "Mensual";
    if (val === 15) return "Quincenal";
    if (val === 7) return "Semanal";
    if (val === 1) return "Diaria";

    return `Cada ${val} días`;
  };

  // =============================
  // SCORE
  // =============================
  const calcularScore = () => {
    if (!data?.resumen?.length) return null;

    const peor = Math.max(
      ...data.resumen.map((r) => Number(r.peor_atraso || 0))
    );

    let estado = "BUENO";
    let color = "green";

    if (peor > 60) {
      estado = "MALO";
      color = "red";
    } else if (peor > 15) {
      estado = "RIESGO";
      color = "orange";
    }

    return { estado, color, peor };
  };

  const score = calcularScore();

  // 🔥 fallback: si no hay resumen, usar detalle
  const resumenData = data?.resumen?.length
    ? data.resumen
    : data?.detalle || [];

  return (
    <div className="container mt-4">
      
<div style={{ position: "relative" }}>

  {/* INPUT (el "select falso") */}
  <Form.Control
    type="text"
    placeholder="Seleccionar cliente"
    value={busqueda}
    onFocus={() => setMostrarLista(true)}
    onChange={(e) => {
      setBusqueda(e.target.value);
      setMostrarLista(true);
    }}
  />

  {/* DROPDOWN */}
  {mostrarLista && (
    <div
      style={{
        position: "absolute",
        width: "100%",
        maxHeight: "200px",
        overflowY: "auto",
        background: "white",
        border: "1px solid #ccc",
        borderTop: "none",
        zIndex: 1000,
      }}
    >
      {clientesFiltrados.length > 0 ? (
        clientesFiltrados.map((c) => (
          <div
            key={c.IdCliente}
            style={{
              padding: "8px",
              cursor: "pointer",
            }}
            onClick={() => {
              setBusqueda(`${c.Nombre} ${c.Apellido}`);
              setMostrarLista(false);
              buscarCliente(c);
            }}
            onMouseOver={(e) =>
              (e.currentTarget.style.background = "#f0f0f0")
            }
            onMouseOut={(e) =>
              (e.currentTarget.style.background = "white")
            }
          >
            {c.Nombre} {c.Apellido}
          </div>
        ))
      ) : (
        <div style={{ padding: "8px", color: "#999" }}>
          Sin resultados
        </div>
      )}
    </div>
  )}
</div>

      {/* LOADING */}
      {loading && <Spinner className="mt-3" />}

      {/* INFO CLIENTE */}
  {clienteInfo && (
  <Card className="mt-3">
    <Card.Body>
      <h5>Datos del Cliente</h5>
      <p><b>Nombre:</b> {clienteInfo.Nombre} {clienteInfo.Apellido}</p>
      <p><b>DNI:</b> {clienteInfo.DNI}</p>
      <p><b>Teléfono:</b> {clienteInfo.Telefono}</p>
      <p><b>Domicilio:</b> {clienteInfo.Domicilio}</p>

      {/* 🔥 OBSERVACIONES DESTACADAS */}
      {clienteInfo.Observaciones && (
        <div
          style={{
            backgroundColor: "#fff3cd",
            border: "1px solid #ffeeba",
            padding: "10px",
            borderRadius: "8px",
            marginTop: "10px"
          }}
        >
          <b>⚠ Observaciones:</b>
          <div>{clienteInfo.Observaciones}</div>
        </div>
      )}
    </Card.Body>
  </Card>
)}

      {/* SCORE */}
{score && (
  <Card className="mt-3 shadow-sm">
    <Card.Body>

      <h4 className="text-center">📊 Evaluación del cliente</h4>

      <h2 style={{ color: score.color }} className="text-center">
        {score.estado}
      </h2>

      <p className="text-center">
        Peor atraso registrado: <b>{score.peor} días</b>
      </p>

      <hr />

      <div className="row text-center">

        <div className="col-md-4">
          <div className="p-2 border rounded bg-light">
            <h6>🟢 BUENO</h6>
            <small>
              Sin atrasos importantes <br />
              Cliente confiable
            </small>
          </div>
        </div>

        <div className="col-md-4">
          <div className="p-2 border rounded bg-light">
            <h6>🟡 RIESGO</h6>
            <small>
              Atrasos mayores a 15 días <br />
              Requiere seguimiento
            </small>
          </div>
        </div>

        <div className="col-md-4">
          <div className="p-2 border rounded bg-light">
            <h6>🔴 MALO</h6>
            <small>
              Atrasos mayores a 60 días <br />
              Alto riesgo de incobrabilidad
            </small>
          </div>
        </div>

      </div>

      <hr />

      <p className="text-center text-muted">
        👉 El estado se calcula según el peor atraso en sus pagos
      </p>

    </Card.Body>
  </Card>
)}


      {/* RESUMEN */}
      {data && (
        <Card className="mt-3">
          <Card.Body>
            <h5>Operaciones</h5>

            <Table striped bordered>
              <thead>
                <tr>
                  <th>Tipo</th>
                  <th>ID</th>
                  <th>Modalidad</th>
                  <th>Cuotas</th>
                  <th>Atrasadas</th>
                  <th>Peor atraso</th>
                  <th>Estado</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {resumenData
                  .sort((a, b) => b.IdPrestamo - a.IdPrestamo)
                  .map((r) => (
                    <React.Fragment key={r.IdPrestamo}>
                      <tr>
                        <td>{r.tipo_operacion}</td>
                        <td>{r.IdPrestamo}</td>
                        <td>{getModalidad(r.modalidad)}</td>

                        <td>{esContado(r) ? "-" : r.total_cuotas ?? 0}</td>
                        <td>{esContado(r) ? "-" : r.cuotas_atrasadas ?? 0}</td>

                        <td style={{ color: (r.peor_atraso || 0) > 15 ? "red" : "black" }}>
                          {esContado(r) ? 0 : r.peor_atraso ?? 0}
                        </td>

                        <td style={{ fontWeight: "bold", color: esContado(r) ? "blue" : "black" }}>
                          {esContado(r)
                            ? "CONTADO"
                            : r.estado_credito || r.estado_cuota}
                        </td>

                        <td>
                          {!esContado(r) && (
                            <Button
                              size="sm"
                              onClick={() =>
                                setDetalleVisible(
                                  detalleVisible === r.IdPrestamo
                                    ? null
                                    : r.IdPrestamo
                                )
                              }
                            >
                              {detalleVisible === r.IdPrestamo
                                ? "Ocultar"
                                : "Ver"}
                            </Button>
                          )}
                        </td>
                      </tr>

                      {/* DETALLE */}
                      {detalleVisible === r.IdPrestamo && (
                        <tr>
                          <td colSpan="8">
                            <Table size="sm">
                              <thead>
                                <tr>
                                  <th>Cuota</th>
                                  <th>Vencimiento</th>
                                  <th>Pago</th>
                                  <th>Atraso</th>
                                </tr>
                              </thead>
                              <tbody>
                                {data.detalle
                                  .filter(
                                    (d) =>
                                      d.IdPrestamo === r.IdPrestamo &&
                                      d.Cuota !== null
                                  )
                                  .map((d, i) => (
                                    <tr key={i}>
                                      <td>{d.Cuota}</td>

                                      <td>
                                        {d.FechaVencimiento
                                          ? new Date(d.FechaVencimiento).toLocaleDateString()
                                          : "-"}
                                      </td>

                                      <td>
                                        {d.FechaRegistro
                                          ? new Date(d.FechaRegistro).toLocaleDateString()
                                          : "-"}
                                      </td>

                                      <td style={{ color: (d.dias_atraso || 0) > 10 ? "red" : "black" }}>
                                        {d.dias_atraso ?? 0}
                                      </td>
                                    </tr>
                                  ))}
                              </tbody>
                            </Table>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  ))}
              </tbody>
            </Table>
          </Card.Body>
        </Card>
      )}
    </div>
  );
};

export default ClienteDashboard;